export const navigation = [
  {
    name_uz: "Smartfon va gadjetlar",
    name_ru: "Смартфоны и гаджеты",
    id:"phone"
  },
  {
    name_uz: "Televizorlar va audio",
    name_ru: "Телевизоры и аудио",
    id:"television"
  },
  {
    name_uz: "Oshxona jihozlari",
    name_ru: "Кухонные приборы",
    id:"#phone"
  },
  {
    name_uz: "Noutbuklar va kompyuterlar",
    name_ru: "Ноутбуки и компьютеры",
    id:"#phone"
  },
  {
    name_uz: "Uy uchun texnikalar",
    name_ru: "Техники для дома",
    id:"#phone"
  },
];
